import { proforientationEventSelectors } from 'portfolio3/features/proforientation/model/selectors';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const proforientationEventProbesYearsSelector = createSelector(
  [proforientationEventSelectors.probes],
  (proforientationEventProbes) =>
    extractDatesFromNestedItems(
      [proforientationEventProbes],
      [
        {
          type: 'date',
          field: 'unformattedEventDate',
        },
      ],
    ),
);
